import { render, staticRenderFns } from "./Starfield.vue?vue&type=template&id=7f7d0cc0&scoped=true&"
import script from "./Starfield.vue?vue&type=script&lang=js&"
export * from "./Starfield.vue?vue&type=script&lang=js&"
import style0 from "./Starfield.vue?vue&type=style&index=0&id=7f7d0cc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d0cc0",
  null
  
)

export default component.exports